import { useStore } from '@xyflow/react';
import { ReactFlowState } from '@xyflow/react';
import { LAYOUT } from '../constants';

const zoomSelector = (state: ReactFlowState) => state.transform[2];

/**
 * Hook to get zoom state and derived values for React Flow canvas
 *
 * @returns Object containing:
 *   - zoom: Current zoom level from React Flow
 *   - isZoomedOut: Whether the canvas is zoomed out below the threshold
 *   - hoverScale: Scale factor to apply on hover for readability (only when zoomed out)
 */
export function useZoomState() {
  const zoom = useStore(zoomSelector);
  const isZoomedOut = typeof zoom === 'number' && zoom < LAYOUT.ZOOM_THRESHOLD;
  const hoverScale = typeof zoom === 'number' && zoom > 0 ? LAYOUT.READABILITY_ZOOM / zoom : 1;

  return {
    zoom,
    isZoomedOut,
    hoverScale,
  };
}
